import Link from 'next/link';
import { useCityStore } from '@/store/useCityStore';
const BASE_URL = process.env.NEXT_PUBLIC_API_URL || '/api/proxy/';

const PopularCities = () => {
    const { cities, isLoading } = useCityStore();
    const popularCities = cities.filter(c => c.show_popular);

    return (
        <section id="cities" className="py-8 lg:py-8">
            <div className="container-custom">
                {/* Section Title */}
                <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-8">
                    <div className="section-title mb-4 md:mb-0">
                        {/* <span className="subtitle">Explore</span> */}
                        <h2>Popular Cities</h2>
                        <p>
                            Discover properties in India's most sought-after cities
                        </p>
                    </div>

                    <Link href="/all-cities" className="btn btn-secondary self-start md:self-end">
                        Explore All Cities
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </Link>
                </div>

                {/* Cities Grid */}
                <div className="flex overflow-x-auto lg:grid lg:grid-cols-6 gap-4 lg:gap-6 scrollbar-hide">
                    {popularCities.map((city) => (
                        <Link
                            key={city.id}
                            href={`/city/${city.slug}`}
                            className="city-card group flex-shrink-0 w-[170px] lg:w-auto"
                        >
                            <img
                                src={BASE_URL + city.image}
                                alt={city.name}
                                loading="lazy"
                            />
                            <div className="overlay">
                                <h3>{city.name}</h3>
                                <p>{city.propertyCount.toLocaleString()}+ properties</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PopularCities;
